"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounceAccumalate = void 0;

var _debouncePromise = _interopRequireDefault(require("debounce-promise"));

var debounceAccumalate = function debounceAccumalate(_ref) {
  var fn = _ref.fn,
      delay = _ref.delay;

  if (delay === 0) {
    return function (args) {
      return fn([args]);
    };
  }

  return (0, _debouncePromise["default"])(function (argTuples) {
    var args = argTuples.map(function (arg) {
      return arg[0];
    });
    return fn(args);
  }, delay, {
    accumulate: true
  });
};

exports.debounceAccumalate = debounceAccumalate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@devicebits/analytics-client/dist/debounceAccumulate.js
// module id = 1025
// module chunks = 0